import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import DialogModal from "../../common/DialogModal";
import NotificationBar from "../../Parts/NotificationBar.jsx";
import ResetPasswordComponent from "../../ResetPassword/ResetPasswordComponent.jsx";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
    minWidth: "600px",
    margin: 0,
  },
});

class ChangePasswordDialog extends React.Component {
  state = {
    message: "",
  };

  componentWillReceiveProps(nextProps) {
    //close dialog when API succeeds
    if (
      this.props.isSaving &&
      !nextProps.isSaving &&
      nextProps.error === null
    ) {
      nextProps.toggleDialog();
    }

    if (!this.props.error && nextProps.error) {
      if (
        nextProps.error &&
        nextProps.error.data &&
        nextProps.error.data.message &&
        typeof nextProps.error.data.message === "string"
      ) {
        this.setState({
          message: nextProps.error.data.message,
        });
      }
    }
  }

  renderErrorMessage = (message) => {
    if (message) {
      return (
        <NotificationBar
          message={message}
          type="error"
          open={true}
          autoClose={false}
          disableOnclickListener={true}
          style={{
            transform: "none",
            boxShadow: "none",
            width: "100%",
            boxSizing: "border-box",
            marginBottom: "20px",
          }}
        ></NotificationBar>
      );
    }
  };

  render() {
    const { classes, toggleDialog, user, isChildEdit } = this.props;

    return (
      <DialogModal
        open={this.props.isOpen}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        onClose={toggleDialog}
        title="パスワードを変更"
        classes={{
          paper: classes.paper,
        }}
      >
        {this.renderErrorMessage(this.state.message)}
        <ResetPasswordComponent
          user={!this.props.isChildEdit ? user : this.props.childUser}
          showPassword={true}
          showSecurityQuestion={false}
          postUsersUpdatePassword={!this.props.isChildEdit ? this.props.postUsersUpdatePassword : this.props.childUserSave}
          isChildEdit={isChildEdit}
          buttonText="保存"
          error={this.props.error}
        />
      </DialogModal>
    );
  }
}

ChangePasswordDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  postUsersUpdatePassword: PropTypes.func.isRequired,
  childUserSave: PropTypes.func,
  isSaving: PropTypes.bool,
  isChildEdit: PropTypes.bool,
  childUser: PropTypes.object,
  user: PropTypes.object,
  error: PropTypes.object,
};

PropTypes.defaultValue = {
  isChildEdit: false,
}

export default withStyles(styles)(ChangePasswordDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/ChangePasswordDialog.jsx